/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} File_Export_Video_TitleInputs */



/**
* | output |
* | --- |
* | "Video File" |
*
* @param {File_Export_Video_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const file_export_video_title = /** @type {((inputs?: File_Export_Video_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<File_Export_Video_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Fichier video")
	if (locale === "de") return /** @type {LocalizedString} */ ("Videodatei")
	if (locale === "it") return /** @type {LocalizedString} */ ("File video")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Видеофайл")
	if (locale === "es") return /** @type {LocalizedString} */ ("Archivo de vídeo")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("视频文件")
	if (locale === "ja") return /** @type {LocalizedString} */ ("ビデオファイル")
	if (locale === "hi") return /** @type {LocalizedString} */ ("वीडियो फाइल")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Arquivo de vídeo")
	return /** @type {LocalizedString} */ ("Video File")
});